import http from "../http-common";
/* eslint-disable no-console */

export default {
    /* eslint-disable no-console */
    retrieveGames(success, error) {
        http
            .get("/games")
            .then(response => {
                console.log(response.data);
                success(response.data); // JSON are parsed automatically.
            })
            .catch(e => {
                error(e);
            });
    },
    getGame(id, success, error) {
        http
            .get("/games/" + id + "/scoresheet")
            .then(response => {
                console.log('retrieved: ' + response.data.toString());
                success(response.data);
            })
            .catch(e => {
                console.log(e + ' retrieving game with id ' + id);
                error(e);
            });
    },
    newGame(data, success, error) {
        http
        .post("/games", data)
        .then(response => {
          success(response.data);
        })
        .catch(e => {
          error(e);
        });
    },
    updateScore(gameId, data, success, error) {
        http
        .post("/games/" + gameId + "/scoresheet/scores", data)
        .then(response => {
            success(response);
        })
        .catch(e => {
          error(e);
        });
    },
    playerOut(gameId, data, success, error) {
        http
        .post("/games/" + gameId + "/scoresheet/player-out", data)
        .then(response => {
            success(response);
        })
        .catch(e => {
          error(e);
        });
    },
    deleteGame(gameId, success, error) {
        http.
        delete("/games/" + gameId).
        then(response => {
            success(response);
        })
        .catch(e => { error(e);});
    }
    /* eslint-enable no-console */
}